import React from 'react';
import TravelMapV2 from '@components/google-maps/TravelMapV2';
import { TravelSuggestion } from '../../../../../../../types/TravelSuggestionType';

type Props = {
  value: {
    travelSuggestion: TravelSuggestion;
  };
};

const TravelSuggestionSerializer =
  () =>
  ({ value: { travelSuggestion } }: Props) => (
    <TravelMapV2 travelMode={travelSuggestion?.travelMode} routePoints={travelSuggestion?.routePoints} />
  );

export default TravelSuggestionSerializer;
